export function getFriendlySectionPath(uuid: string, name: string) {
  // Remove all non-alphanumeric characters excluding whitespace from name
  const friendlyName = name.replace(/[^a-zA-Z0-9\s]/g, '').toLowerCase();
  // Replace all whitespace with dashes
  const friendlyNameWithDashes = friendlyName.replace(/\s/g, '-');
  const short_uuid = uuid.substring(0, 8);
  return `${friendlyNameWithDashes}-${short_uuid}`;
}
